// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

import options from "../utils/options";
import Icons from "../../icons";
import TextWidget from "./text";
import { Button } from "../../button";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./text-array.scss";

type Props = $Exact<{
  ...SchemaTableWidgetProps<Array<string>>,
  ...PropsFromLocalize,
}>;

export class TextArrayWidget extends React.Component<Props> {
  handleAdd = () => {
    const next = [...this.props.data, ""];
    this.props.onChange(next);
  };

  handleChange = (index: number) => (value: ?string) => {
    const next = this.props.data.map((d: string, i: number) => (i === index ? value || "" : d));
    this.props.onChange(next);
  };

  handleDelete = (index: number) => () => {
    const next = this.props.data.slice(0);
    next.splice(index, 1);

    this.props.onChange(next);
  };

  render() {
    const { data, ...rest } = this.props;

    if (!this.props.active) {
      return (
        <div className="text-array__readonly">
          {data &&
            data.map((d: string) => (
              <div key={d} className="text-array__readonly-item">
                {this.props.data}
              </div>
            ))}
        </div>
      );
    }

    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    return (
      <div
        className={classNames("text-array__container", {
          "text-array__container--disabled": disabled,
        })}
      >
        {data &&
          data.map((d: string, i: number) => (
            <div key={i} className="text-array__row">
              {/* $$FlowIgnore */}
              <TextWidget {...rest} data={d} onChange={this.handleChange(i)} />
              <Icons.CloseIcon
                onClick={this.handleDelete(i)}
                color={disabled ? "disabled" : "charcoal-dark"}
              />
            </div>
          ))}
        <Button materialIcon="add_box" className="mt-2 align-self-end" onClick={this.handleAdd}>
          {this.props.t("ADD")}
        </Button>
      </div>
    );
  }
}

export default localize()(TextArrayWidget);
